import { DocumentSummaryEntryMode } from '@/types/schema';
import { formatDateToMMDDYY } from '@/utils/formatting/dates';

export interface AttributionParams {
  entryMode: DocumentSummaryEntryMode | null;
  updateUser?: {
    displayName?: string | null;
  } | null;
  updatedAt?: Date | null;
  includeDate?: boolean;
  /**
   * When true, renders AI-generated attribution as "Summary complete" instead
   * of "Generated by AI". Used in contexts where the AI provenance should not
   * be surfaced (e.g. the documents table status column).
   */
  useSummaryCompleteLabel?: boolean;
}

/**
 * Returns attribution text for a document based on entry mode and user information
 */
export function getDocumentAttributionText({
  entryMode,
  updateUser,
  updatedAt,
  includeDate = false,
  useSummaryCompleteLabel = false,
}: AttributionParams): string {
  if (
    entryMode === DocumentSummaryEntryMode.AiAuto ||
    entryMode === DocumentSummaryEntryMode.AiUserInvoked
  ) {
    if (useSummaryCompleteLabel) {
      if (includeDate && updatedAt) {
        return `Summary completed on ${formatDateToMMDDYY(updatedAt)}`;
      }
      return 'Summary complete';
    }
    if (includeDate && updatedAt) {
      return `Generated by AI on ${formatDateToMMDDYY(updatedAt)}`;
    }
    return 'Generated by AI';
  }

  if (entryMode === DocumentSummaryEntryMode.User) {
    const userName = updateUser?.displayName || 'Unknown User';

    if (includeDate && updatedAt) {
      return `Updated by ${userName} on ${formatDateToMMDDYY(updatedAt)}`;
    }

    return `Updated by ${userName}`;
  }

  return '';
}
